import { Observable, map } from 'rxjs';

import { WorkPackageStatusDto } from '@api/backend-connector/models';
import {
  SmartPickerHandler,
  SmartPickerPage,
  defaultSmartPickerOptions,
} from 'src/app/components-form/smart-input-entity/smart-picker.handler';
import { WorkPackageStatusService } from 'src/app/services/work-package-status.service';

type WorkPackageStatusPickerContext = void;

export class WorkPackageStatusPickerHandler extends SmartPickerHandler<WorkPackageStatusDto> {
  constructor(
    private workPackageStatusService: WorkPackageStatusService,
    private context?: WorkPackageStatusPickerContext,
  ) {
    super({
      ...defaultSmartPickerOptions,
      virtualScroll: false,
      filter: {
        enabled: false,
      },
      initialFetchedItems: 20,
      preloadStrategy: { enabled: true, autoSelectSingleChoice: true },
    });
  }

  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  override getItems(params: {
    offset?: number | undefined;
    limit?: number | undefined;
    query?: string;
    excludeIds: string[] | undefined;
  }): Observable<SmartPickerPage<WorkPackageStatusDto>> {
    return this.workPackageStatusService
      .allActiveWorkPackageStatuses({
        excludeIds: params.excludeIds,
      })
      .pipe(
        map((items) => ({
          items,
          count: items.length,
          limit: items.length,
          offset: 0,
        })),
      );
  }
}
